// components/ui/LoadingSpinner.jsx
export default function LoadingSpinner({ size = "md" }) {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };

  return (
    <div data-component-id="src/components/ui/LoadingSpinner.jsx:10:4" data-component-path="src/components/ui/LoadingSpinner.jsx" data-component-line="10" data-component-file="LoadingSpinner.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${sizeClasses[size]} border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin`} />
  );
}